/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Header_TitleInputs */

const es_admin_header_title = /** @type {(inputs: Admin_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de administrador`)
};

const en_admin_header_title = /** @type {(inputs: Admin_Header_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin panel`)
};

/**
* | output |
* | --- |
* | "Admin panel" |
*
* @param {Admin_Header_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_header_title = /** @type {((inputs?: Admin_Header_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Header_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_header_title(inputs)
	return en_admin_header_title(inputs)
});
export { admin_header_title as "admin.header.title" }